import { Grid } from '@mui/material';
import { memo } from 'react';
import { CommonCivilStatusFormVM } from 'civil-status/view-models/document-birth-form';

interface DescriptionFormProps {
  values?: CommonCivilStatusFormVM;
}

const DescriptionFormComponent = ({ values }: DescriptionFormProps): React.ReactElement => {
  return (
    <Grid container item xs={12} spacing={2}>
      <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-3">Anno: {values?.year || ''}</span>
      <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
        Registro: {values?.registerNumber || ''}
      </span>
      <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
        Atto: {values?.documentNumber || ''}
      </span>
      <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">
        Parte: {values?.portion || ''}
      </span>
      <span className="pmi-d-block pmi-d-md-inline pmi-pl-md-2">Serie: {values?.serie || ''}</span>
    </Grid>
  );
};

DescriptionFormComponent.displayName = 'Description form component';

const DescriptionForm = memo(DescriptionFormComponent);

export default DescriptionForm;
